<template>
  <div>
    <h3 class="h-title">服务要素信息</h3>
    <el-form class="e-form f-b" ref="cForm1" :model="cForm1" label-width="200px"  label-position="left" :rules="cRules">
      <el-form-item label="选择成员单位" prop="lawFirmObj">
        <el-select v-model="cForm1.lawFirmObj" @change="setLawFirm" value-key="nodeId" placeholder="请选择成员单位" style="width: 100%">
          <el-option
            v-for="dict in lawOptions"
            :key="dict.nodeId"
            :label="dict.nodeName"
            :value="dict"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择权威节点" prop="authorityNodeArr">
        <el-select v-model="cForm1.authorityNodeArr" 
        @remove-tag="changeNode" 
        @change="seteNode" multiple         
        filterable 
        @input.native="filterData"
        @clear="clearData"
        value-key="nodeName" placeholder="请选择权威节点" style="width: 100%">
          <el-option
            v-for="item in nodeOptions"
            :key="item.id"
            :label="item.nodeName"
            :disabled="item.isRequire == '0'"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="存储类型" prop="saveType">
        <el-select v-model="cForm1.saveType" placeholder="请选择存储类型" style="width: 100%">
          <el-option
            v-for="dict in typeOptions"
            :key="dict.dictValue"
            :label="dict.dictLabel"
            :value="dict.dictValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="合同类型" prop="contractType">
        <el-select v-model="cForm1.contractType" placeholder="请选择合同类型" style="width: 100%">
          <el-option
            v-for="dict in contractOptions"
            :key="dict.dictValue"
            :label="dict.dictLabel"
            :value="dict.dictValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="主合同名称" prop="mainContractName">
        <el-input v-model="cForm1.mainContractName" :maxlength="50" placeholder="请输入<=50文字" />
      </el-form-item>
      <el-form-item label="主合同编号" prop="mainContractNo">
        <el-input v-model="cForm1.mainContractNo" :maxlength="50" placeholder="请输入<=50文字" />
      </el-form-item>
      <el-form-item label="主合同期限" prop="mainContractPeriod">
          <el-date-picker  style="width: 100%"
              format="yyyy-MM-dd" 
              value-format="yyyy-MM-dd"
              placeholder="请选择"
              v-model="cForm1.mainContractPeriod"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
      </el-form-item>
      <el-form-item label="消费投资场所/服务机构" prop="consumerInvestPlace">
        <el-input v-model="cForm1.consumerInvestPlace" :maxlength="50" placeholder="请输入<=50文字" />
      </el-form-item>
      <el-form-item class="w-70" label="主合同金额(万元)" prop="mainContractAmount" >
        <el-input-number v-model="cForm1.mainContractAmount" controls-position="right" @blur="tipPop('mainContractAmount')" :precision="2" :step="0.1" :min="cForm1.consensusAmount||0" placeholder="请输入数字，小数点后2位" style="width: 100%"></el-input-number>
      </el-form-item> 
      <el-form-item class="w-70" label="共识金额(万元)" prop="consensusAmount">
        <el-input-number v-model="cForm1.consensusAmount" controls-position="right" @blur="tipPop('consensusAmount')" :precision="2" :step="0.1" :min="0" :max="cForm1.mainContractAmount||Infinity" placeholder="请输入数字，小数点后2位" style="width: 100%"></el-input-number>
      </el-form-item> 
      <el-form-item label="主合同签约主体1名称" prop="mainContractSignName1">
        <el-input v-model="cForm1.mainContractSignName1"  :maxlength="50" placeholder="请输入<=50文字" />
      </el-form-item>
      <el-form-item label="主合同签约主体2名称" prop="mainContractSignName2">
        <el-input v-model="cForm1.mainContractSignName2" :maxlength="50" placeholder="请输入<=50文字" />
      </el-form-item>
      <div v-for="index in mainContractSignNum" :key="index">
        <el-form-item :label="`主合同签约主体${index+2}名称`" :prop="`mainContractSignName${index+2}`" :rules="[{required: true,message:'请输入',trigger:'blur'}]">
          <el-input v-model="cForm1['mainContractSignName'+(index+2)]" :maxlength="50" placeholder="请输入<=50文字" style="width: 80%" />
          <el-button class="s-but" type="orange" @click="delMainNum(index)" style="width: 15%; margin: 0 0 0 5%">删除</el-button>
        </el-form-item>
      </div>
      
      <el-button v-show="mainContractSignNum<8" class="s-but" style="margin-top:5px" icon="el-icon-plus" type="orange" @click="addMainNum">其他签约主体</el-button>

      <!-- 从合同 -->
      <div v-if="cForm1.mainContractAmount > cForm1.consensusAmount">
        <el-form-item label="从合同名称" prop="subContractName" :rules="[{required: true,message:'请输入',trigger:'blur'}]">
          <el-input v-model="cForm1.subContractName" :maxlength="50" placeholder="请输入<=50文字"/>
        </el-form-item>
        <el-form-item label="从合同编号" prop="subContractNo" :rules="[{required: true,message:'请输入',trigger:'blur'}]">
          <el-input v-model="cForm1.subContractNo" :maxlength="50" placeholder="请输入<=50文字"/>
        </el-form-item>
        <el-form-item label="从合同期限" prop="subContractPeriod" :rules="[{required: true,message:'请选择',trigger:'change'}]">
            <el-date-picker  style="width: 100%"
                format="yyyy-MM-dd" 
                value-format="yyyy-MM-dd"
                placeholder="请选择"
                v-model="cForm1.subContractPeriod"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
        </el-form-item>
        <el-form-item class="w-70" label="从合同金额(元)" prop="subContractAmount" :rules="[{required: true,message:'请输入',trigger:'blur'}]">
          <el-input-number v-model="cForm1.subContractAmount" controls-position="right" @blur="conversion('subContractAmount')" :precision="2" :step="0.1" :min="0" placeholder="请输入数字，小数点后2位" style="width: 100%"></el-input-number>
        </el-form-item> 
        <el-form-item label="从合同签约主体1名称" prop="subContractSignName1" :rules="[{required: true,message:'请输入',trigger:'blur'}]">
          <el-input v-model="cForm1.subContractSignName1" :maxlength="50" placeholder="请输入<=50文字"/>
        </el-form-item>
        <el-form-item label="从合同签约主体2名称" prop="subContractSignName2" :rules="[{required: true,message:'请输入',trigger:'blur'}]">
          <el-input v-model="cForm1.subContractSignName2" :maxlength="50" placeholder="请输入<=50文字"/>
        </el-form-item>
        <div v-for="i in subContractSignNum" :key="'s'+i">
          <el-form-item :label="`从合同签约主体${i+2}名称`" :prop="`subContractSignName${i+2}`" :rules="[{required: true,message:'请输入',trigger:'blur'}]">
            <el-input v-model="cForm1['subContractSignName'+(i+2)]" :maxlength="50" placeholder="请输入<=50文字" style="width: 80%" />
            <el-button class="s-but" type="orange" @click="delSubNum(i)" style="width: 15%; margin: 0 0 0 5%">删除</el-button>
          </el-form-item>
        </div>

        <el-button v-show="subContractSignNum<8" class="s-but" style="margin-top:5px" icon="el-icon-plus" type="orange" @click="addSubNum">其他签约主体</el-button>
      </div>
    </el-form>
    <div class="cenrer">			
      <el-button class="s-but" type="orange" @click="cSubmitForm('0')" :loading="butLoading">保 存</el-button>
      <el-button class="s-but" type="orange" @click="cSubmitForm('1')" :loading="butLoading">下一步</el-button>
    </div>
  </div>
</template>

<script>
import { elFormErrorScrollIntoView } from '@/utils/util'
import baseUrl from '@/api/baseUrl.js'
export default {
  name: "step1",
  props: ["active", "id"],
  data() {
    return {
      headers: {},
      action: '',
      file: '',
      butLoading: false,
      cFileList: [],
      cForm1: {},
      // 表单校验
      cRules: {
        lawFirmObj: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        authorityNodeArr: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        saveType: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        contractType: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        mainContractName: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        mainContractNo: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        mainContractPeriod: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        consumerInvestPlace: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        mainContractAmount: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        consensusAmount: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        mainContractSignName1: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        mainContractSignName2: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
      },
      lawOptions: [],
      nodeOptions: [],
      nodeTotal: 0,
      typeOptions: [],
      contractOptions: [],
      lawFirmOptions: [],
      mainContractSignNum: 0,
      subContractSignNum: 0,
      mainContractSignList: [],
      subContractSignList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 1000,
        businessType:'5', 
        status: '0'
      },
    }
  },
  watch: {
    active(newVal) {
        if(newVal == 1) {
          window.scrollTo(0,0);
          var param = JSON.parse(sessionStorage.setpForm);
          param.consensusAmount = param.consensusAmount/10000
          param.mainContractAmount = param.mainContractAmount/10000
          this.cForm1 = param
          this.getLawFirm()
          this.getNodeList()
          this.init()
        } 
    }
  },
  mounted(){
      this.action = `${baseUrl.iaccUrl}/iacc-contract-platform/common/uploadFile`;    
      this.$api.api.getDicts("xf_save_type").then(response => {
          this.typeOptions = response.data;
      });
      this.$api.api.getDicts("xf_contract_type").then(response => {
        this.contractOptions = response.data;
      });
      if(this.id) {
        this.getDetial();
      }else{
        this.getLawFirm()
        this.getNodeList()
        this.init()
      }    
    },
  methods: { 
    init(){
        if(this.cForm1.mainContractPeriodStart){
          this.$set(this.cForm1, 'mainContractPeriod', [this.cForm1.mainContractPeriodStart, this.cForm1.mainContractPeriodEnd])       
        }
        if(this.cForm1.subContractPeriodStart){
          this.$set(this.cForm1, 'subContractPeriod', [this.cForm1.subContractPeriodStart, this.cForm1.subContractPeriodEnd])       
        }

        // 金额
        if(this.cForm1.mainContractAmount == null){
          delete this.cForm1.mainContractAmount
        }
        if(this.cForm1.consensusAmount == null){
          delete this.cForm1.consensusAmount
        }
        if(this.cForm1.subContractAmount == null){
          delete this.cForm1.subContractAmount
        }

        // 主体个数
        for(let j=10; j>2; j--){
          if(this.cForm1['mainContractSignName'+(j)]){
            this.mainContractSignNum = j-2;
            return
          }
        }
        // 从合同主体个数
        for(let j=10; j>2; j--){
          if(this.cForm1['subContractSignName'+(j)]){
            this.subContractSignNum = j-2;
            return
          }
        }
      },
    //获取详情
    getDetial() {
      this.$api.consumer.proDetail(this.id).then(res => {
            if(res.code==200){
                this.cForm1 = Object.assign({}, res.data); 	
                this.getLawFirm()
                this.getNodeList()
                this.init()
            }else {
                this.$message.error(res.msg);
            }    
        });      
    },
    // 查询权威节点
    filterData(e){
      this.queryParams.pageNum = 1
      this.queryParams.nodeName = e.target.value;
      this.selectNode();
    },
    // 清空权威节点
    clearData() {
      this.queryParams.nodeName = ""
      this.queryParams.pageNum = 1
      this.selectNode();
    },
    selectNode(){
      this.$api.api.nodeList({...this.queryParams, nodeType: '1'}).then(response => {
        if(response.code == 200){
          this.nodeOptions = response.rows
        }else {
          this.$message.error(response.msg);
        } 
      })
    },
    tipPop(name){
      this.conversion(name)
      if(this.cForm1.mainContractAmount && this.cForm1.consensusAmount && this.cForm1.mainContractAmount != this.cForm1.consensusAmount){
        this.$confirm('共识金额与合同金额不一致，请在拟存储文件中出县证明文件。')
          .then(_ => {})
          .catch(_ => {});
      }
    },
    conversion(name) {
      this.cForm1[name+'Rmb'] = this.smalltoBIG(this.cForm1[name]*10000);
    },
    /** 数字金额大写转换(可以处理整数,小数,负数) */    
    smalltoBIG(n){    
      let fraction = ['角', '分'];    
      let digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];    
      let unit = [ ['元', '万', '亿'], ['', '拾', '佰', '仟']  ];    
      let head = n < 0? '欠': '';    
      n = Math.abs(n);    
    
      let s = '';    
    
      for (let i = 0; i < fraction.length; i++)     
      {    
          s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');    
      }    
      s = s || '整';    
      n = Math.floor(n);    
    
      for (let i = 0; i < unit[0].length && n > 0; i++)     
      {    
          let p = '';    
          for (let j = 0; j < unit[1].length && n > 0; j++)     
          {    
              p = digit[n % 10] + unit[1][j] + p;    
              n = Math.floor(n / 10);    
          }    
          s = p.replace(/(零.)*零$/, '').replace(/^$/, '零')  + unit[0][i] + s;    
      }    
      return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整');    
    },
    addMainNum(){
      this.mainContractSignNum++
    },
    delMainNum(i){
      let mainArry = []
      for(let j=0; j<this.mainContractSignNum; j++ ){
        mainArry[j] = this.cForm1['mainContractSignName'+(j+3)]
      }
      this.mainContractSignNum--
      mainArry.splice(i-1, 1)

      for(let m=0; m<this.mainContractSignNum; m++ ){
        this.cForm1['mainContractSignName'+(m+3)] = mainArry[m]
      }
      this.cForm1['mainContractSignName'+(this.mainContractSignNum+3)] = ""
    },
    addSubNum(){
      this.subContractSignNum++
    },
    delSubNum(i){
      let subArry = []
      for(let j=0; j<this.subContractSignNum; j++ ){
        subArry[j] = this.cForm1['subContractSignName'+(j+3)]
      }
      this.subContractSignNum--
      subArry.splice(i-1, 1)

      for(let m=0; m<this.subContractSignNum; m++ ){
        this.cForm1['subContractSignName'+(m+3)] = subArry[m]
      }
      
      this.cForm1['subContractSignName'+(this.subContractSignNum+3)] = ""
    },    
    changeNode(item){
      if(item.isRequire == '0'){
        this.$message.error("此项为必须项，不能删除！");
        this.cForm1.authorityNodeArr.push(item)
      }
    },
    seteNode(obj){
      this.clearData()
      obj.forEach((item, i) => {
        if(item.nodeName == this.cForm1.lawFirmName){
          this.$message.error("律所与权威节点不能选择相同机构！");
          this.cForm1.authorityNodeArr.splice(i, 1)
        }
      })
    },
    setLawFirm(obj){
      // 律所与权威节点不能相同
      let index = this.cForm1.authorityNodeArr.findIndex((item) => item.nodeName === obj.deptName); 
      if(index >= 0){
        this.$message.error("律所与权威节点不能选择相同机构！");
        delete this.cForm1['lawFirmObj']
      }else {
        this.cForm1.lawFirmName = obj.nodeName
        this.cForm1.lawFirm = obj.nodeId
      }      
    },
    getLawFirm(){
      this.queryParams.nodeName = ''
      this.$api.api.nodeList({...this.queryParams,nodeType:'2'}).then(response => {
          if(response.code == 200){
            this.lawOptions = response.rows 
            if(this.cForm1.lawFirmName){
              this.$set(this.cForm1, 'lawFirmObj', {
                nodeName: this.cForm1.lawFirmName,
                nodeId: this.cForm1.lawFirm
              })
            }
          }else {
            this.$message.error(response.msg);
          }      
        });
    },
    uniqueFun(arr,type){
      const res = new Map();
      return arr.filter((a)=>!res.has(a[type])&& res.set(a[type],1));
    },
    getNodeList(){
      this.$api.api.nodeList({...this.queryParams, nodeType: '1'}).then(response => {
        if(response.code == 200){
          this.nodeOptions = response.rows
          this.nodeTotal = response.total
          let authorityArr = []    
          this.nodeOptions.forEach(item => {
            if(item.isRequire == '0'){
              authorityArr.push({
                id: item.id,
                nodeName: item.nodeName
              })
            }
          })  
          if(this.cForm1.authorityNode){            
            let nodeArr = JSON.parse(this.cForm1.authorityNode)
            nodeArr.forEach(item =>{
              if(this.nodeOptions.findIndex((v) => {return v.id == item.id;}) >= 0){
                authorityArr.push({
                  id: item.id,
                  nodeName: item.name
                })
              }             
            })
          }    
          this.$set(this.cForm1, 'authorityNodeArr', this.uniqueFun(authorityArr, 'id')) 
        }else {
          this.$message.error(response.msg);
        }      
      });
    },
    prev() {
      sessionStorage.setpForm = JSON.stringify(this.cForm1);
      this.$emit('prev')
    },
    cSubmitForm(type){
      // 用户经理
      this.cForm1.userManager = sessionStorage.applyCustomerName
      this.cForm1.userManagerPhone = sessionStorage.applyCustomerContact
      this.cForm1.userManagerAccount = sessionStorage.applyCustomerAccount
      this.cForm1.submitName = sessionStorage.projectName
      if(this.cForm1.mainContractPeriod){
        this.cForm1.mainContractPeriodStart = this.cForm1.mainContractPeriod[0]
        this.cForm1.mainContractPeriodEnd = this.cForm1.mainContractPeriod[1]
      }
      if(this.cForm1.subContractPeriod){
        this.cForm1.subContractPeriodStart = this.cForm1.subContractPeriod[0]
        this.cForm1.subContractPeriodEnd = this.cForm1.subContractPeriod[1]
      } 
      if(type == '0'){                  
        this.butLoading = true;
        this.cForm1.status = '0'
        this.cForm1.authorityNode = []
        this.cForm1.authorityNodeArr.forEach(item => {
          this.cForm1.authorityNode.push({
            id: item.id,
            name: item.nodeName
          })
        })
        this.cForm1.authorityNode = JSON.stringify(this.cForm1.authorityNode)
        var param = Object.assign({}, this.cForm1)
        param.consensusAmount = param.consensusAmount*10000
        param.mainContractAmount = param.mainContractAmount*10000
        // param.subContractAmount = param.subContractAmount*10000        
        this.$api.consumer.addAndUpd(JSON.stringify(param)).then(response => {
          this.butLoading = false;
          if(response.code == 200){
            sessionStorage.removeItem("setpForm")
            this.$message.success("保存成功");
            this.$router.go(-1);
          }     
        });
        
      }else{
        this.$refs["cForm1"].validate(valid => {
          if (valid) {
            if(this.nodeTotal >= 4){
              if(this.cForm1.authorityNodeArr.length !== 4){
                this.$message.error("权威节点请选择4个！");
                return false
              }
            }else {
              if(this.cForm1.authorityNodeArr.length !== this.nodeTotal){
                this.$message.error("权威节点请选择"+this.nodeTotal+"个！");
                return false
              }
            }
            this.cForm1.authorityNode = []
            this.cForm1.authorityNodeArr.forEach(item => {
              this.cForm1.authorityNode.push({
                id: item.id,
                name: item.nodeName
              })
            })
            this.cForm1.authorityNode = JSON.stringify(this.cForm1.authorityNode)
            var param = Object.assign({}, this.cForm1)
            param.consensusAmount = param.consensusAmount*10000
            param.mainContractAmount = param.mainContractAmount*10000
            // param.subContractAmount = param.subContractAmount*10000
            sessionStorage.setpForm = JSON.stringify(param);
            this.$emit('next');
          }else {
            this.$nextTick(() => {
              elFormErrorScrollIntoView()
            })
          }
        }) 
      }  
    },
    handleError(err, file, fileList){
      this.$message.error(file.name + "文件上传失败");
    },
    beforeUpload(file) { 	
      const isLt2M = file.size / 1024 / 1024 <= 80     //这里做文件大小限制
      
      if(!isLt2M) {
        this.$message.error('上传文件大小不能超过 80MB！');
      }
      return isLt2M
    },
    cUpload(response, file, list){
        if(response.code == 200){
          this.cForm1.fileName = file.name
          this.cForm1.fileHash = response.data.hash
          this.$set(this.cForm1, 'fileUrl', response.data.path)
        }else{
            this.$message.error(file.name + "文件上传失败");
            this.cForm1.fileName = ''
            this.cForm1.fileHash = ''
            this.cForm1.fileUrl = ''
            this.cFileList = []
        }              
    },
    handleCRemove(file, fileList) {
      this.cForm1.fileName = ''
      this.cForm1.fileHash = ''
      this.cForm1.fileUrl = ''
      this.cFileList = []
    },
  }
}
</script>
